import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import {
  TAuditObjectsHistoryParams,
  TAuditObjectsHistoryRes,
  TAuditObjectsIdParams,
  TAuditObjectsIdRes,
  TAuditObjectsParams,
  TAuditObjectsRes,
} from '../types/audit.types';

export const getAuditObjectsService = async (
  params?: TAuditObjectsParams
): Promise<TAuditObjectsRes> => {
  const config = { params };
  const url = API_ENDPOINTS.AUDIT.AUDIT_OBJECTS;
  const res = await apiClient.get(url, config);

  return res?.data;
};

export const getAuditObjectsHistoryService = async (
  params?: TAuditObjectsHistoryParams
): Promise<TAuditObjectsHistoryRes> => {
  const config = { params };
  const url = API_ENDPOINTS.AUDIT.AUDIT_OBJECTS_HISTORY;
  const res = await apiClient.get(url, config);

  return res?.data;
};

export const getAuditObjectsIdService = async (
  params?: TAuditObjectsIdParams
): Promise<TAuditObjectsIdRes> => {
  const config = { params };
  const url = API_ENDPOINTS.AUDIT.AUDIT_OBJECTS_ID;
  const res = await apiClient.get(url, config);

  return res?.data;
};
